import { db } from '../firebase';
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  Timestamp
} from 'firebase/firestore';

// 🔹 Collection reference
const noticesCollection = collection(db, 'notices');

/**
 * Create Notice (Maker)
 */
export const createNotice = async (noticeData) => {
  const nowUTC = Timestamp.now();

  const payload = {
    ...noticeData,
    status: 'pending',
    createdAt: nowUTC,
    updatedAt: nowUTC,
  };

  const docRef = await addDoc(noticesCollection, payload);
  return docRef.id;
};

/**
 * Update Notice (Only when Pending)
 */
export const updateNotice = async (noticeId, updateData) => {
  const noticeRef = doc(db, 'notices', noticeId);

  await updateDoc(noticeRef, {
    ...updateData,
    updatedAt: Timestamp.now()
  });
};

/**
 * Approve Notice
 */
export const approveNotice = async (noticeId, approverId) => {
  const noticeRef = doc(db, 'notices', noticeId);

  await updateDoc(noticeRef, {
    status: 'approved',
    approvedBy: approverId,
    approvedAt: Timestamp.now(),
    updatedAt: Timestamp.now()
  });
};

/**
 * Withdraw Notice
 */
export const withdrawNotice = async (noticeId) => {
  const noticeRef = doc(db, 'notices', noticeId);

  await updateDoc(noticeRef, {
    status: 'withdrawn',
    updatedAt: Timestamp.now()
  });
};

/**
 * Get All Notices for Tenant
 */
export const getNoticesByTenant = async (tenantId) => {
  const q = query(
    noticesCollection,
    where('tenantId', '==', tenantId),
    orderBy('createdAt', 'desc')
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

/**
 * Get Approved Notices for Display
 */
export const getApprovedNotices = async (tenantId) => {

  const q = query(
    collection(db, "notices"),
    where("tenantId", "==", tenantId)
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

};

/**
 * Get Single Notice
 */
export const getNoticeById = async (noticeId) => {
  const noticeRef = doc(db, 'notices', noticeId);
  const snapshot = await getDoc(noticeRef);

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data()
  };
};

/**
 * Get Pending Notices for Approval
 */
export const getPendingNotices = async (tenantId) => {
  const q = query(
    collection(db, 'notices'),
    where('tenantId', '==', tenantId),
    where('status', '==', 'pending')
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

export const rejectNotice = async (noticeId, approverId) => {
  const noticeRef = doc(db, 'notices', noticeId);

  await updateDoc(noticeRef, {
    status: 'rejected',
    approvedBy: approverId,
    approvedAt: Timestamp.now(),
    updatedAt: Timestamp.now()
  });
};

export const deleteNotice = async (noticeId) => {
  const noticeRef = doc(db, 'notices', noticeId);
  await deleteDoc(noticeRef);
};

export const getUserNotices = async (userId) => {
  const q = query(
    collection(db, 'notices'),
    where('createdBy', '==', userId)
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};